import React, { useContext, useState } from "react";

const HtmlContext = React.createContext();
const SetHtmlContext = React.createContext();

export function useHtml() {
  return useContext(HtmlContext);
}

export function useSetHtml() {
  return useContext(SetHtmlContext);
}

export function HtmlProvider({ children }) {
  const [html, setHtml] = useState("");

  return (
    <HtmlContext.Provider value={html}>
      <SetHtmlContext.Provider value={setHtml}>
        {children}
      </SetHtmlContext.Provider>
    </HtmlContext.Provider>
  );
}
